import httpClient from '@/api/http-client';
import { type BusinessPhoneVerification, BusinessPhoneVerificationChannel } from "@/models/business-phone-verification.model";

/* eslint-disable no-unreachable */

async function getStatus (businessId: string) {
  const { data } = await httpClient.get<BusinessPhoneVerification>(
    `/businesses/${businessId}/phone-verification`
  );
  return data;
}

async function sendCode (businessId: string, channel: BusinessPhoneVerificationChannel) {
  const { data } = await httpClient.post<BusinessPhoneVerification>(
    `/businesses/${businessId}/phone-verification/send-code`,
    {
      channel,
    }
  );

  return data;
}

async function checkCode (businessId: string, code: string) {
  const { data } = await httpClient.post<BusinessPhoneVerification>(
    `/businesses/${businessId}/phone-verification/check-code`,
    {
      code,
    }
  );
  return data;
}

export default {
  getStatus,
  sendCode,
  checkCode,
};
